import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { NavBar } from "./components/NavBar";
import { EccentricNav } from "./components/EccentricNav";
import { Projects } from "./components/Projects";
import { ResumePage } from "./components/ResumePage";
import { LiquidBackground } from "./components/LiquidBackground";
// import { BackgroundTheme } from './components/background-theme/BackgroundTheme';

import './theme.css';

function App() {
  return (
    <Router>
      <LiquidBackground enablePointerRipples={false} />
      <Routes>
        <Route path="/" element={<div className="App page-layer"><EccentricNav /><Projects /></div>} />
        <Route path="/resume" element={<div className="page-layer"><EccentricNav /><ResumePage /></div>} />
      </Routes>
    </Router>
  );
}

export default App;
